
import { React, ui, theme, pr, observer, observable } from "aaa";
import { withFormsy } from "formsy-react";
import { IFormsyComponentProps } from "./FormsyProps";

type IProps = {
    onInfo?: () => void;
    label: React.ReactNode;
    onCheck: (event: any, checked: boolean) => void;

    // html input attributes
    disabled?: boolean;
    required?: boolean;
    defaultChecked?: boolean;
};

@observer
export class GeorgeCheckbox extends React.Component<IProps> {
    @observable checked = false;
    @observable focus = false;

    constructor(props: IProps) {
        super(props);
        if (this.props.defaultChecked) {
            this.checked = true;
        }
    }

    onChange = (event: any) => {
        this.checked = event.target.checked;
        if (this.props.onCheck) {
            this.props.onCheck(event, this.checked);
        }
    }

    renderIcon() {
        const size = 33;
        const color = this.checked ? "#00a8ff" : "#B8C4D1";
        const style = {
            width: size,
            height: size,
            color
        };
        return (
            <div
                style={{
                    boxShadow: this.focus ? `inset ${theme.focusShadow}` : "none",
                    width: size,
                    height: size,
                    borderRadius: 4,
                    transition: "box-shadow 0.2s"
                }}
            >
                {this.checked && <pr.IconCheckbox style={style} />}
                {!this.checked && <pr.IconCheckboxOutline style={style} />}
            </div>
        );
    }

    render() {
        // Have to do it this way instead of manually forwarding components, because
        // setting checked={props.checked} with props.checked === undefined leads
        // to a ccheckbox that is always off and not checkable
        const { onInfo, ...checkboxProps } = this.props;

        const checkbox = (

            <label
                className="theme-paragraph-color"
                style={{
                    fontSize: 14,
                    color: this.props.disabled ? theme.customColors.georgeLightGrey : undefined,
                    maxWidth: Math.min(ui.windowWidth, theme.MAX_APP_WIDTH) * 0.8, // Fix for IE overflowing
                    cursor: "pointer",
                    position: "relative"
                }}
            >
                <input
                    type="checkbox"
                    onChange={this.onChange}
                    style={{ opacity: 0, position: "absolute" }}
                    checked={this.checked}
                    disabled={this.props.disabled}
                    required={this.props.required}
                    onFocus={() => this.focus = true}
                    onBlur={() => this.focus = false}
                />
                <div style={{ display: "flex" }}>
                    <div
                        style={{
                            marginRight: 4,
                            marginTop: -6
                        }}
                    >
                        {this.renderIcon()}
                    </div>

                    <div>{this.props.label}</div>
                </div>
            </label>
        );

        if (!this.props.onInfo) {
            return checkbox;
        } else {
            return (
                <pr.HFlex style={{ width: "100%" }}>
                    <div style={{ flex: 1 }}>
                        {checkbox}
                    </div>
                    <div
                        role="button"
                        aria-label={ui.__("a11y.information")}
                    >
                        <pr.IconInfo
                            style={{
                                width: 30,
                                height: 30,
                                color: theme.customColors.georgeLightBlue,
                                cursor: "pointer",
                                zIndex: 10
                            }}
                            onClick={this.props.onInfo}
                        />
                    </div>
                </pr.HFlex>
            );
        }
    }
}

class CheckboxFormsy extends React.Component<IProps & IFormsyComponentProps, {}> {
    changeValue = (event: any, index: number, value: string) => {
        // setValue() will set the value of the component, which in
        // turn will validate it and the rest of the form
        // Important: Don't skip this step. This pattern is required
        // for Formsy to work.
        this.props.setValue(value);
    }

    onCheck = (event: any, checked: boolean) => {
        this.props.setValue(checked);
        if (this.props.onCheck) {
            this.props.onCheck(event, checked);
        }
    }

    render() {
        return <GeorgeCheckbox
            defaultChecked={this.props.defaultChecked}
            disabled={this.props.disabled}
            label={this.props.label}
            onCheck={this.onCheck}
        />;
    }
}

export const GeorgeCheckboxFormsy = withFormsy(CheckboxFormsy);



// WEBPACK FOOTER //
// ./src/components/common/GeorgeCheckbox.tsx